import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganisationPlugins } from 'src/app/constants/settings.enum';
import { Organisation } from 'src/app/models/organisation';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: './platformapi.modal.html'
})
export class PlatformAPIModal implements OnInit {
  env:string = "";
  environment = environment;
  bridgeIntegrationUrl: SafeUrl = "";
  iframeHeight: number = 330;
  private url = "";
  private _pluginCode = "";
  @Input() set pluginCode(code: string) {
    this._pluginCode = code;
    if(code === OrganisationPlugins.AFAS){
      this.url = "afasbridge.pkisigning.io/settings";
    } else if(code === OrganisationPlugins.Visionplanner){
      this.url = "vpbridge.pkisigning.io"
    }
  }
  get pluginCode(){
    return this._pluginCode;
  }
  
  constructor(private activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    this.setBridgeUrl();
    if(this._pluginCode === OrganisationPlugins.AFAS){
      this.setEventListener();
    }
  }

  setEventListener() {
    const childWindow = <HTMLIFrameElement>document!.getElementById('bridgeIntegrationUrl') as HTMLIFrameElement;
    window.addEventListener('message', (event: any) => {
        let origin = event.origin.split('/');
        
        if (origin.length < 3 || origin[0] !== "https:" && ((origin[2].indexOf("afasbridge.pkisigning.io") > -1 ) || (origin[2].indexOf("localhost")>-1))) return;

        if (event.source !== childWindow.contentWindow) {
            return;
        }
        if(event.data.message.toLocaleLowerCase() === "closemodal") this.closeDialog();
        if(event.data.iframeHeight) this.iframeHeight = event.data.iframeHeight;
        if(this.iframeHeight > 720) this.iframeHeight = 720;
        return;
    });
  }
  
  setBridgeUrl() {
    switch(this.environment.platformname.toLocaleLowerCase()){
      case "development": 
        this.env = "dev";
        break;
      case "test": 
        this.env = "test";
        break;
      case "acceptatie": 
        this.env = "acc";
        break;
      case "productie": 
        this.env = "";
        break;
      default:
        this.env = ""; 
        break;
    }
    this.bridgeIntegrationUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://"+ this.env + this.url);
  }

  closeDialog() {
    this.activeModal.close(false);
  }

}
